import { fetch } from "../../../../shared/services/api.service";
import { checkApiSuccess } from "../../../../utils";
import config  from '../../../../env.config'
import { requestMethod } from "../../../../config";

export const addActivityLog = async (payload) => {
  const requestConfig = {
      method: requestMethod.POST,
      url: `${config.BASE_URL.BASE_API_URL}/task/addActivityLog`,
      data: payload,
    }, 
    response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  }
};